import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Donate } from '../Api/Donate';
import { Toast } from '../hooks/useToast';


export const fetchDonateHistoryThunk = createAsyncThunk(
    'donateHistory/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await Donate.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)

export const deleteDonateHistoryThunk = createAsyncThunk(
    'donateHistory/delete',
    async ({ slug, setDonateList, donateType, user_slug }, { getState }) => {
        try {
            Toast('Deleting donate history', 'loading', true)
            const { api_token } = getState().profile.data;
            const response = await Donate.delete(slug, api_token);
            const { data } = getState().donateHistory;
            const newData = data.map(item => {
                if (item.slug !== user_slug) return item;
                if (item[donateType].length === 1) {
                    setDonateList(prev => {
                        return {
                            ...prev,
                            [donateType]: []
                        }
                    })
                    return {
                        ...item,
                        [donateType]: []
                    }
                }
                const new_arr = item[donateType].filter(list => list.slug !== slug);
                setDonateList(prev => {
                    return {
                        ...prev,
                        [donateType]: new_arr
                    }
                })
                return {
                    ...item,
                    [donateType]: new_arr
                }
            }).filter(Boolean)
            Toast('Donate history deleted successfully', 'success', false)
            return newData
        } catch (err) {
            Toast(err.message, 'error', false)
            return Promise.reject(err.message);
        }
    }
)



const initialState = {
    status: "pending",
    data: [],
}

export const donateHistorySlice = createSlice({
    name: 'donateHistory',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },
    },
    extraReducers: {
        [fetchDonateHistoryThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchDonateHistoryThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [fetchDonateHistoryThunk.rejected]: (state, action) => {
            state.status = "error"
        },
        [deleteDonateHistoryThunk.fulfilled]: (state, action) => {
            state.data = action.payload
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, resetState } = donateHistorySlice.actions

export default donateHistorySlice.reducer